import { render } from "./Privacy.vue?vue&type=template&id=09cd2708&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=09cd2708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cd2708"]])

export default __exports__